import React from "react";
import { FaTrophy } from "react-icons/fa";
import { RiRoadMapLine } from "react-icons/ri";
import { FaTags } from "react-icons/fa6";
import { FaMapPin } from "react-icons/fa";

const Features = () => {
  return (
    <div className="container-fluid feature py-5">
      <div className="container py-5">
        <div
          className="text-center mx-auto pb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "800px" }}
        >
          <h1 className="display-5 text-capitalize mb-3">
            Central <span className="text-primary">Features</span>
          </h1>
          <p className="mb-0">
            At Steward Cars, we provide top-notch car rental services tailored
            to your needs. Discover our exceptional features!
          </p>
        </div>
        <div className="row g-4 align-items-center">
          <div className="col-xl-4">
            <div className="row gy-4 gx-0">
              <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
                <div className="feature-item">
                  <div className="feature-icon">
                    <span className="fa-2x">
                      <FaTrophy />
                    </span>
                  </div>
                  <div className="ms-4">
                    <h5 className="mb-3">First-Class Services</h5>
                    <p className="mb-0">
                      Experience luxury and comfort with our well-maintained
                      fleet. Your satisfaction is our priority!
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 wow fadeInUp" data-wow-delay="0.3s">
                <div className="feature-item">
                  <div className="feature-icon">
                    <span className="fa-2x">
                      <RiRoadMapLine />
                    </span>{" "}
                  </div>
                  <div className="ms-4">
                    <h5 className="mb-3">24/7 Road Assistance</h5>
                    <p className="mb-0">
                      Enjoy peace of mind with our round-the-clock road
                      assistance, ensuring you're never stranded.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-12 col-xl-4 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <img
              src="img/features-img.png" // Update with relevant image
              className="img-fluid w-100"
              style={{ objectFit: "cover" }}
              alt="Features"
            />
          </div>
          <div className="col-xl-4">
            <div className="row gy-4 gx-0">
              <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
                <div className="feature-item justify-content-end">
                  <div className="text-end me-4">
                    <h5 className="mb-3">Quality at Competitive Rates</h5>
                    <p className="mb-0">
                      Get the best value for your money with our affordable
                      rental rates without compromising on quality.
                    </p>
                  </div>
                  <div className="feature-icon">
                    <span className="fa-2x">
                      <FaTags />
                    </span>{" "}
                  </div>
                </div>
              </div>
              <div className="col-12 wow fadeInUp" data-wow-delay="0.3s">
                <div className="feature-item justify-content-end">
                  <div className="text-end me-4">
                    <h5 className="mb-3">Free Pick-Up & Drop-Off</h5>
                    <p className="mb-0">
                      Enjoy the convenience of free pick-up and drop-off
                      services to make your rental experience seamless.
                    </p>
                  </div>
                  <div className="feature-icon">
                    <span className="fa-2x">
                      <FaMapPin />
                    </span>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
